import { render } from "./icon-alert.svg?vue&type=template&id=43887e9c?inline"
const script = {}
script.render = render

export default script